import React from 'react';
const subStats = [{
  value: '10 Volumi',
  label: '+ 5 bonus, dalla primaria alla terza media'
}, {
  value: '60 Unità',
  label: 'Già strutturate: attività, scheda, verifica'
}, {
  value: '100%',
  label: 'Pronto da stampare, senza preparazione'
}];
export function BetterWay() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-38" data-mp="wzicdvx846bl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-39" data-mp="x11tfoqpelef">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-40" data-mp="11x0bkulfv76e">
          La Tua Trasformazione in Aula
        </p>
        <h2 className="mx-auto mt-5 max-w-3xl text-[28px] font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-41" data-mp="16yzgwa0qoe5z">
          Da Insegnante in Difficoltà a{' '}
          <em className="italic text-grape" data-id="element-42" data-mp="1fx1nr675m116">Guida Musicale Sicura.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-43" data-mp="3crej3ad2co1d">
          Musica Pronta trasforma ogni lezione di musica — anche se non hai una formazione musicale
          specifica — con materiali pronti, corretti e allineati al programma.
        </p>

        <dl className="mt-12 grid gap-5 sm:grid-cols-3" data-id="element-44" data-mp="3f8w66gef1yr5">
          {subStats.map(stat => <div key={stat.value} className="rounded-3xl border border-navy/10 bg-white px-6 py-8 text-center" data-id="element-45" data-mp="3b9f1hp6td5n1">
              <dt className="sr-only" data-id="element-46" data-mp="367fw69rijyng">{stat.label}</dt>
              <dd data-id="element-47" data-mp="6sudyczp7o0h">
                <span className="block font-display text-2xl font-extrabold text-orange" data-id="element-48" data-mp="6tcgfrcyeygu">
                  {stat.value}
                </span>
                <span className="mt-3 block text-sm font-medium leading-snug text-ink-soft" data-id="element-49" data-mp="3tylecvkxf30x">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}